var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('HorizontalNav',{attrs:{"navs":_vm.navs}}),_c('section',{staticClass:"mt-4"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }